import {
    GET_MANAGED_EQUIPMENT_DROP_DOWN,
    SET_MANAGED_EQUIPMENT_DROP_DOWN
} from "./ManagedEquipmentDropDownType"

const getManagedEquipmentDropDown = (subTypeId: number) => {
    return ({
        type: GET_MANAGED_EQUIPMENT_DROP_DOWN,
        assetSubTypeId: subTypeId
    })
};

const setManagedEquipmentDropDown = (managedEquipmentDropDown: any) => ({
    type: SET_MANAGED_EQUIPMENT_DROP_DOWN,
    managedEquipmentDropDown: managedEquipmentDropDown,
});

export {
    getManagedEquipmentDropDown,
    setManagedEquipmentDropDown
}